import { z } from "zod";

export const SiteSimilarityDtoSchema = z.object({
  siteId: z.string().uuid(),
  similarity: z.number(),
});

export type SiteSimilarityDto = z.infer<typeof SiteSimilarityDtoSchema>;
